import * as JSCookie from 'js-cookie';
import React from 'react'
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from "stores/ducks/User.duck";

import { AppConfig } from 'config/app';

/**
 * This is the component that Stripe redirects a user to after completing the express dashboard setup.
 */
class PaymentSetup extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false
        }
    }

    public componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        const userId = query.get('userId')
        const stripeId = query.get('stripeId')
        fetchGraphQL(`
            mutation {
                user {
                    confirmStripeStandardSetup(userId:"${userId}", stripeId:"${stripeId}")
                }
            }
        `).then(response => {
            JSCookie.remove('user');
            JSCookie.remove('token');
            window.location.href = AppConfig.hostUrl + '/login';
        })
    }

    public render() {
        return null
    }

}

const mapStateToProps = state => {
    return {
        user: UserDucks.getUser(state)
    };
};

export default withCookies(withRouter(connect(mapStateToProps)(PaymentSetup)));


// WEBPACK FOOTER //
// ./src/components/app/StripeConnect/PaymentSetup.tsx